import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    (async () => {
      try {
        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) throw new Error("Kein session_id im URL-Fragment.");
        const session_id = decodeURIComponent(match[1]);
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data);
        // Clean the URL hash
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (_e) {
        navigate("/login?google_error=1", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#FCFCFB] text-[#5A5B5C]"
      data-testid="auth-callback"
    >
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-6 w-6 animate-spin text-[#A7B584]" />
        <div className="text-sm">Sitzung wird hergestellt…</div>
      </div>
    </div>
  );
}
